import React from "react";
import "../css/ApprovalStatus.css";
import { getTimezoneString } from "../../../utils/dateUtils";
import { AUTO_APPROVAL_MESSAGE } from "../../../utils/constants";

const ApprovalStatus = ({
  isTripCancelled,
  email,
  airport,
  trackingId,
  timestamp,
  isAutoCompleted,
  isExempted = false,
}) => {
  const showExemptionSignature = isExempted;
  const showAutoApprovalMessage = isAutoCompleted && !isExempted;
  const showApprovalSignature = !isAutoCompleted && !isExempted;

  return (
    <div className="approval-container">
      <h2 className="approval-title">
        {showAutoApprovalMessage ? AUTO_APPROVAL_MESSAGE : ""}{" "}
        {showExemptionSignature && "Exempted by Airport Authority"}
        {showApprovalSignature &&
          (isTripCancelled ? "Cancelled by" : "Approved by ") + "Airport Authority"}
      </h2>
      {(showExemptionSignature || showApprovalSignature) && (
        <p className="approval-title">
          <a href={`mailto:${email}`} className="approval-email">
            {email}
          </a>
          _{airport}_{trackingId} _{timestamp} ({getTimezoneString()})
        </p>
      )}
    </div>
  );
};

export default ApprovalStatus;
